export default function formatMemberId(memberid){

    return memberid.replace("-", "").toUpperCase();
    
}